import React from "react";
import "./DigiHero.css"; // Import CSS for styling

const SchemeHero= () => {
  return (
    <div className="digihero-container">
      <img
        src="assets/schemes/schemes.png"
        alt="Digi Hero"
        className="digihero-image"
      />
    </div>
  );
};

export default SchemeHero;